import { inject } from '@angular/core';

import { ClientConfigProductName, ProductService } from '@frontend/vanilla/core';

import { BingoHostProductService } from './host-app/bingo-host-product.service';
import { BingoAppLazyBootstrapService } from './host-app/bootstrap/bingo-app-lazy-bootstrap.service';

export const bingoProductDeactivateGuard = () => {
    inject(ProductService).deactivateProduct(ClientConfigProductName.BINGO);
    inject(BingoHostProductService).removeBingoHostAppClass();
};

export const bingoProductActivateGuard = () => {
    inject(ProductService).setActive(ClientConfigProductName.BINGO);
    inject(BingoHostProductService).addBingoHostAppClass();
    return inject(BingoAppLazyBootstrapService).onBingoAppInit();
};
